
export default function UnAuthorized() {
    return (
        <div style={{textAlign: "center"}}>
            <p style={{fontSize: '2rem', color: '#0b456e'}}>UnAuthorized</p>
        </div>
    )
}